export const CREATED = "created";
export const UPDATED = "updated";
export const REMOVED = "removed";
export const UPLOADED = "uploaded";
export const REGISTRED = "registred";
